import React from 'react';
import './dynamicListPagesFooter.scss';
import i18n from '../../../utils/i18n';
import BkLogoWhite from '../assets/BkLogoWhite.svg';
import LinkedInIcon from '../assets/DlpFooter/DlpFooterLinkedInIcon.svg';
import TikTokIcon from '../assets/DlpFooter/DlpFooterTikTokIcon.svg';
import FacebookIcon from '../assets/DlpFooter/DlpFooterFacebookIcon.svg';
import InstagramIcon from '../assets/DlpFooter/DlpFooterInstagramIcon.svg';
import EnvelopeIcon from '../assets/DlpFooter/DlpFooterEnvelopeIcon.svg';
import MobileIcon from '../assets/DlpFooter/DlpFooterMobileIcon.svg';
import MapIcon from '../assets/DlpFooter/DlpFooterMapIcon.svg';

const DynamicListPagesFooter = () => {
	return (
		<div className="dynamicListPagesFooter">
			<div className="dlpFooterGrid">
				<div className="dlpFooterLogoContainer">
					<a
						href="https://www.bookkeepie.com/hu"
						target="_blank"
						rel="noopener noreferrer">
						<img
							src={BkLogoWhite}
							alt="Bk Logo White"
							className="dlpFooterBkLogoWhite"
						/>
					</a>
					<p>A kereső oldal ahol a könyvelők és ügyfeleik találkoznak</p>
					<div className="dlpFooterSocialIcons">
						<a
							href="https://hu.linkedin.com/company/bookkeepie-hu"
							target="_blank"
							rel="noopener noreferrer">
							<img src={LinkedInIcon} alt="LinkedIn" />
						</a>
						<a
							href="https://www.facebook.com/BookkeepieHU/"
							target="_blank"
							rel="noopener noreferrer">
							<img src={FacebookIcon} alt={i18n.t('hardcoded.facebook')} />
						</a>
						<a
							href="https://www.instagram.com/bookkeepie_hu/"
							target="_blank"
							rel="noopener noreferrer">
							<img src={InstagramIcon} alt={i18n.t('hardcoded.instagram')} />
						</a>
						<a
							href="https://www.tiktok.com/@bookkeepie_hu"
							target="_blank"
							rel="noopener noreferrer">
							<img src={TikTokIcon} alt="TikTok" />
						</a>
					</div>
				</div>
				<div className="dlpFooterLinksContainer">
					<div className="dlpFooterLinksSection">
						<p>
							<a
								href="https://www.bookkeepie.com/hu/bemutatkozo"
								target="_blank"
								rel="noopener noreferrer">
								Bemutatkozás
							</a>
						</p>
						<p>
							<a
								href="https://www.bookkeepie.com/hu/konyvelot-keresoknek"
								target="_blank"
								rel="noopener noreferrer">
								Könyvelőt keresőknek
							</a>
						</p>
						<p>
							<a
								href="https://www.bookkeepie.com/hu/konyveloknek"
								target="_blank"
								rel="noopener noreferrer">
								Könyvelőknek
							</a>
						</p>
						<p>
							<a
								href="https://www.bookkeepie.com/hu/ajanloi-program"
								target="_blank"
								rel="noopener noreferrer">
								Ajánlói program
							</a>
						</p>
					</div>
					<div className="dlpFooterLinksSection">
						<p>
							<a
								href="https://www.bookkeepie.com/hu/blog"
								target="_blank"
								rel="noopener noreferrer">
								Blog
							</a>
						</p>
						<p>
							<a
								href="https://www.bookkeepie.com/hu/sajtomegjeleneseink"
								target="_blank"
								rel="noopener noreferrer">
								Sajtómegjelenéseink
							</a>
						</p>
						<p>
							<a
								href="https://ie.bookkeepie.com/contact-us"
								target="_blank"
								rel="noopener noreferrer">
								Kapcsolat
							</a>
						</p>
					</div>
				</div>
				<div className="dlpFooterContactsSection">
					<div className="dlpFooterContactsSectionIcons">
						<img src={EnvelopeIcon} alt={i18n.t('hardcoded.envelopeIcon')} />
						<p>
							<a
								href="mailto:info-hu@bookkeepie.hu"
								target="_blank"
								rel="noopener noreferrer">
								info-hu@bookkeepie.hu
							</a>
						</p>
					</div>
					<div className="dlpFooterContactsSectionIcons">
						<img src={MobileIcon} alt={i18n.t('hardcoded.mobileIcon')} />
						<p>
							<a
								href="tel:+36202383689"
								target="_blank"
								rel="noopener noreferrer">
								+36 20 238 3689
							</a>
						</p>
					</div>
					<div className="dlpFooterContactsSectionIcons">
						<img src={MapIcon} alt={i18n.t('hardcoded.mapIcon')} />
						<p>
							<a
								href="https://www.google.com/maps?q=1071+Budapest,+Damjanich+utca+19"
								target="_blank"
								rel="noopener noreferrer">
								1071 Budapest, Damjanich utca 19.
							</a>
						</p>
					</div>
				</div>
			</div>
			<div className="dlpFooterBottom">
				<p>© 2025 Bookkeepie.com - Minden jog fenntartva.</p>
				<p>
					<a
						href="https://drive.google.com/file/d/1vPD0t4Jl1WeifR4QLcmiNeBUh_pxX8_1/view"
						target="_blank"
						rel="noopener noreferrer">
						Adatvédelmi tájékoztató
					</a>
					<a
						href="https://drive.google.com/file/d/1AHgVYNzt6z0v5wLyuL7KLTgMsyyUU3za/view"
						target="_blank"
						rel="noopener noreferrer">
						ÁSZF
					</a>
					<a
						href="https://drive.google.com/file/d/164rAYxR128QlvBRZQjH7uGYr0a8r5r0Y/view"
						target="_blank"
						rel="noopener noreferrer">
						SimplePay fizetési tájékoztató
					</a>
				</p>
			</div>
		</div>
	);
};

export default DynamicListPagesFooter;
